import { ConversationMessageView } from '@mark43/cad-api';
import { useRef } from 'react';
import { ConversationKey } from '../models';

const otherParticipantColors = [
    'var(--cad-colors-message-sender-blue)',
    'var(--cad-colors-message-sender-pink)',
    'var(--cad-colors-message-sender-green)',
    'var(--cad-colors-message-sender-red)',
    'var(--cad-colors-message-sender-teal)',
    'var(--cad-colors-message-sender-orange)',
    'var(--cad-colors-message-sender-purple)',
    'var(--cad-colors-message-sender-cyan)',
    'var(--cad-colors-message-sender-yellow)',
    'var(--cad-colors-message-sender-gray)',
];

type ConversationSenderColorMap = {
    conversationKey: ConversationKey | undefined;
    senderColorMap: Record<string, string>;
};

export const useMessageSenderColor = (selectedConversationKey?: ConversationKey) => {
    const conversationSenderColorMap = useRef<ConversationSenderColorMap>();

    if (
        selectedConversationKey === undefined ||
        conversationSenderColorMap.current === undefined ||
        !selectedConversationKey.equals(conversationSenderColorMap.current.conversationKey)
    ) {
        conversationSenderColorMap.current = {
            conversationKey: selectedConversationKey,
            senderColorMap: {},
        };
    }

    const getColor = (message: ConversationMessageView) => {
        if (
            message.isSender ||
            conversationSenderColorMap.current === undefined ||
            message.conversationId !== selectedConversationKey?.conversationId
            // the conversationId validation is needed because for some reason a <MessageRow> from the previous
            // selected conversation is being rendered momentarily when selecting a new conversation which
            // is grabbing the first color (blue) meaning that the first color is incorrectly pink not blue.
        ) {
            return 'text.primary';
        }

        const { senderColorMap } = conversationSenderColorMap.current;
        const senderLabel = message.sender.label;

        if (senderColorMap[senderLabel] === undefined) {
            const senderIndex = Object.keys(senderColorMap).length;
            const colorIndex = senderIndex % otherParticipantColors.length;
            const senderColor = otherParticipantColors[colorIndex];
            senderColorMap[senderLabel] = senderColor;
        }

        return senderColorMap[senderLabel];
    };

    return getColor;
};
